import React, { BaseSyntheticEvent } from 'react';
import { useFormikContext } from 'formik';
import { Box, Button, Checkbox, FormControlLabel, FormHelperText, Link } from '@mui/material';
import { GenericObject } from '@fnol/library/src/lib';
import { translations, personType, riskType, riskTypeLife } from '../../lib/consts';

type PersonProps = {
    type: personType;
    id?: number;
    userAttorney?: boolean;
};

const AMLSection = ({ type, id, userAttorney }: PersonProps) => {
    const { values, errors, touched, setFieldValue } = useFormikContext<GenericObject>();

    const idUser = id ? id : '';
    const attorneySignature = `${personType[type]}${idUser}AttorneySignature`;

    const onCheckboxAMLSection = (e: BaseSyntheticEvent) => {
        setFieldValue(attorneySignature, e.target.checked);
    };

    return (
        <>
            <Box>
                <Button variant="contained" sx={{ width: 'max-content', marginTop: '20px' }}>
                    <Link
                        target="_blank"
                        href={values.amlURL}
                        rel="noreferrer"
                        sx={{ color: '#fff', textDecoration: 'none' }}
                    >
                        {translations.AML_FOR_CLIENT}
                    </Link>
                </Button>

                {values.risks.includes(riskTypeLife.purchase) && values.userTypePurchase === 2 && (
                    <Button variant="contained" sx={{ width: 'max-content', marginTop: '20px', marginLeft: '20px' }}>
                        <Link
                            target="_blank"
                            href={values.ownerIdURL}
                            rel="noreferrer"
                            sx={{ color: '#fff', textDecoration: 'none' }}
                        >
                            {translations.FORM_ID_OWNER}
                        </Link>
                    </Button>
                )}
            </Box>

            <FormControlLabel
                name={attorneySignature}
                control={<Checkbox />}
                onChange={onCheckboxAMLSection}
                label={userAttorney ? translations.ATTORNEY_SIGNATURE : translations.USER_SIGNATURE}
                checked={values[attorneySignature]}
                sx={{ width: 'max-content', marginBottom: '20px' }}
            />
            {touched[attorneySignature] && errors[attorneySignature] ? (
                <FormHelperText error={true}>
                    <>{errors[attorneySignature]}</>
                </FormHelperText>
            ) : null}
        </>
    );
};

export const AMLSectionCleanup = (
    type: personType,
    setFieldValue: (field: string, value: string | number, shouldValidate?: boolean | undefined) => void,
    userId?: number,
) => {
    const idUser = userId ? userId : '';
    setFieldValue(`${personType[type]}${idUser}AttorneySignature`, '');
};

export default AMLSection;
